var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 246.037 246.037",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M217.984,40.463H28.053C12.585,40.463,0,53.048,0,68.516v109.005c0,15.468,12.585,28.053,28.053,28.053h189.932 c15.468,0,28.053-12.585,28.053-28.053V68.516C246.037,53.048,233.453,40.463,217.984,40.463z M28.053,56.463h189.932 c6.646,0,12.053,5.407,12.053,12.053v10.697H16V68.516C16,61.87,21.407,56.463,28.053,56.463z M217.984,189.574H28.053 c-6.646,0-12.053-5.407-12.053-12.053v-63.717h214.037v63.717C230.037,184.167,224.63,189.574,217.984,189.574z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.091,
    cy: 161.077,
    r: 8.767
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.236,
    cy: 161.077,
    r: 8.767
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.381,
    cy: 161.077,
    r: 8.767
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.255,
    cy: 161.077,
    r: 8.767
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.4,
    cy: 161.077,
    r: 8.767
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.11,
    cy: 161.077,
    r: 8.767
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardsLogo);
export default __webpack_public_path__ + "static/media/CreditCardsLogo.8d93c1d5141e85897fb68a84c8133b4b.svg";
export { ForwardRef as ReactComponent };